<template>
<div class="webrtc_face_detector">
    <div class="see x-face-detect-modal">
      <video
        id="myVideo"
        poster="/static/images/camloding.png"
        muted
        loop
        playsinline
        @loadedmetadata="fnRun"
         ref="faceBox"
      ></video>
      <canvas id="myCanvas" />
      <img v-if="loaded" src="/static/images/detecting.png" style="width: 100%;height:100%;" />
      <div v-if="isSuccess||isFailed" :style="`position: absolute;width: 100%;height:100%;background:#fff`" >
        <el-result v-if="isSuccess" icon="success" title="验证通过" style="transform:scaleX(-1); height:-webkit-fill-available">
        </el-result>
        <el-result v-if="isFailed" icon="error" title="验证失败" style="transform:scaleX(-1); height:-webkit-fill-available">
        </el-result>
      </div>
    </div>
  </div>
</template>

<script>
import * as faceapi from "face-api.js";
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    visibleFlag: Boolean,
    examId: String,
  },
  components: {},
  data() {
    // :width="constraints.video.width.ideal" :height="constraints.video.height.ideal"
    return {
      nets: "tinyFaceDetector", // 模型
      options: null, // 模型参数
      detectFace: "detectSingleFace", // 单or多人脸
      videoEl: null,
      canvasEl: null,
      canvas: null,
      timeout: 0,
      loaded: false,
      isSuccess: false,
      isFailed: false,
      faceChkTimes: 0,
      global,
      // 视频媒体参数配置
      constraints: {
        audio: false,
        video: {
          // ideal（应用最理想的）
          width: {
            min: 320,
            ideal: 500,
            max: 1920,
          },
          height: {
            min: 240,
            ideal: 480,
            max: 1080,
          },
          // frameRate受限带宽传输时，低帧率可能更适宜
          frameRate: {
            min: 15,
            ideal: 30,
            max: 60,
          },
          // 显示模式前置后置
          facingMode: "user",
        },
      },
      sendLiving: false,
    };
  },

  created() {},
  mounted() {
    if (this.global.isPhone()) {
      this.constraints.video.width = 300;
      this.constraints.video.height = 280;
    }
    this.$nextTick(() => {
      this.fnInit();
      this.fnOpen();
    });
  },
  watch: {
    visibleFlag(newVal) {
      if (!newVal) {
        this.fnClose();
        this.loaded = false;
        this.$forceUpdate();
      } else {
        this.fnOpen();
      }
    },
  },
  methods: {
    async fnInit() {
      await faceapi.nets[this.nets].loadFromUri("/models");
      // 根据模型参数识别调整结果
      switch (this.nets) {
        case "ssdMobilenetv1":
          this.options = new faceapi.SsdMobilenetv1Options({
            minConfidence: 0.5, // 0.1 ~ 0.9
          });
          break;
        case "tinyFaceDetector":
          this.options = new faceapi.TinyFaceDetectorOptions({
            inputSize: 512, // 160 224 320 416 512 608
            scoreThreshold: 0.5, // 0.1 ~ 0.9
          });
          break;
        case "mtcnn":
          this.options = new faceapi.MtcnnOptions({
            minFaceSize: 20, // 0.1 ~ 0.9
            scaleFactor: 0.709, // 0.1 ~ 0.9
          });
          break;
      }
      // 节点属性化
      this.videoEl = document.getElementById("myVideo");
      this.canvasEl = document.getElementById("myCanvas");
    },
    // 节点对象执行递归识别绘制
    async fnRun() {
      // 识别绘制人脸信息
      if(this.$refs.faceBox)
        this.$emit("chgWidth", this.$refs.faceBox.clientWidth + 50 + "px");
      const result = await faceapi[this.detectFace](this.videoEl, this.options);
      this.loaded = true;
      if (result && !this.videoEl.paused) {
        const dims = faceapi.matchDimensions(this.canvasEl, this.videoEl, true);
        const resizeResults = faceapi.resizeResults(result, dims);
        faceapi.draw.drawDetections(this.canvasEl, resizeResults);
        if (!this.sendLiving && result._score > 0.6) {
          //this.videoEl.pause();
          this.sendLiving = true;
          this.canvasEl
            .getContext("2d")
            .clearRect(0, 0, this.canvasEl.width, this.canvasEl.height);
          this.canvasEl
            .getContext("2d")
            .drawImage(
              this.videoEl,
              0,
              0,
              this.canvasEl.width,
              this.canvasEl.height
            ); // 绘制到 canvas
          let image = this.canvasEl.toDataURL("image/png");
          console.log(image);
          this.canvasEl
            .getContext("2d")
            .clearRect(0, 0, this.canvasEl.width, this.canvasEl.height);
          image = image.replace("data:image/png;base64,", "");
          this.$axios
            .post(`/api/examRecords/checkFace/${this.examId}`, { image })
            .then((res) => {
              if (res.data && res.data.success) {
                localStorage.setItem(
                  "chkFaceToken004",
                  res.data.checkfacetoken
                );
                this.isSuccess = true;
                this.videoEl.pause();
                setTimeout(() => this.$emit("VerfiyPass"), 3000);
              } else {
                this.sendLiving = false;
               // if (this.faceChkTimes++ > 2) {
                  this.isFailed = true;
                  setTimeout(() => this.$emit("VerfiyFailed"), 3000);
               // }
              }
            })
            .catch((e) => {
              this.sendLiving = false;
            });
        }
      } else {
        this.canvasEl
          .getContext("2d")
          .clearRect(0, 0, this.canvasEl.width, this.canvasEl.height);
      }
      this.timeout = setTimeout(() => this.fnRun(),3000);
    },
    // 启动摄像头视频媒体
    fnOpen() {
      if (typeof window.stream === "object") return;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        clearTimeout(this.timeout);
        navigator.mediaDevices
          .getUserMedia(this.constraints)
          .then(this.fnSuccess)
          .catch(this.fnError);
      }, 300);
    },
    // 成功启动视频媒体流
    fnSuccess(stream) {
      window.stream = stream; // 使流对浏览器控制台可用
      this.videoEl.srcObject = stream;
      this.videoEl.play();
    },
    // 失败启动视频媒体流
    fnError(error) {
      console.log(error);
      alert("视频媒体流获取错误" + error);
    },
    // 结束摄像头视频媒体
    fnClose() {
      this.canvasEl
        .getContext("2d")
        .clearRect(0, 0, this.canvasEl.width, this.canvasEl.height);
      this.videoEl.pause();
      clearTimeout(this.timeout);
      if (typeof window.stream === "object") {
        window.stream.getTracks().forEach((track) => track.stop());
        window.stream = "";
        this.videoEl.srcObject = null;
      }
    },
  },
  beforeDestroy() {
    this.fnClose();
  },
};
</script>
<style >
.see {
  position: relative;
}
.see canvas {
  position: absolute;
  top: 0;
  left: 0;
}
.x-face-detect-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  transform: rotateY(180deg);
}
.x-face-detect-modal img {
  position: absolute;
  top: 0;
}
.x-face-detect-modal video {
  object-fit: fill;
}
</style>
